export default "__VITE_ASSET__W3Ac0E6X__"